// src/features/services/components/ServiceStatusBadge.tsx
import type { ServiceStatus } from '../types/service.types';

export interface ServiceStatusBadgeProps {
  status: ServiceStatus;
}

const STATUS_LABEL: Record<ServiceStatus, string> = {
  active: 'فعال',
  inactive: 'غیرفعال',
  archived: 'بایگانی شده',
};

const STATUS_COLOR_VAR: Record<ServiceStatus, string> = {
  active: 'var(--vania-accent-teal, #2fd6a7)',
  inactive: 'var(--vania-accent-amber, #f5b942)',
  archived: 'var(--vania-accent-rose, #ff6b81)',
};

/**
 * Small pill badge mapping a service's raw status to its Persian
 * label + accent color. Same shape/markup as
 * customers/components/CustomerStatusBadge.tsx (label map + color-var
 * map keyed by the union type) — kept local to this feature since the
 * status union (active/expired/suspended/pending) is service-specific.
 */
export function ServiceStatusBadge({ status }: ServiceStatusBadgeProps) {
  const color = STATUS_COLOR_VAR[status];

  return (
    <span className="vania-service-status-badge" style={{ color, borderColor: color }}>
      <span aria-hidden className="vania-service-status-dot" style={{ backgroundColor: color }} />
      {STATUS_LABEL[status]}
    </span>
  );
}
